export default __webpack_public_path__ + "static/media/0014.4900f12c.svg";